import axios, { AxiosResponse } from "axios";
import { AxiosRequestConfig } from "axios";

const getDefaultHeader = () => {
  return {
    Accept: `*/*`,
    "Content-Type": `application/json`,
    "Access-Control-Allow-Origin": `*`,
  };
};

const getDefaultOptions = (): AxiosRequestConfig => {
  return {
    headers: getDefaultHeader(),
  };
};

function isSuccessStatus(res: AxiosResponse) {
  return res.status >= 100 && res.status <= 399;
}

async function get(
  urlPart: string,
  params: {},
  succFunc: (res: AxiosResponse) => void,
  errFunc?: (res: AxiosResponse) => void,
) {
  const options = getDefaultOptions();
  if (params != null && Object.keys(params).length > 0) {
    options[`params`] = params;
  }
  await axios
    .get(urlPart, options)
    .catch((error) => {
      if (error) errorFunction(error, errFunc);
    })
    .then((res) => {
      if (res) {
        if (isSuccessStatus(res)) {
          if (typeof succFunc === "function") {
            succFunc(res);
          }
        } else {
          if (typeof errFunc === "function") {
            errFunc(res);
          }
        }
      }
    });
}

async function post(
  urlPart: string,
  bodyObj: any,
  succFunc: (res: AxiosResponse) => void,
  errFunc: (res: AxiosResponse | string) => void,
) {
  const options = getDefaultOptions();
  return await axios
    .post(urlPart, bodyObj, options)
    .catch(function (error) {
      errorFunction(error, errFunc);
    })
    .then((res) => {
      if (res) {
        if (isSuccessStatus(res)) {
          if (typeof succFunc === "function") {
            succFunc(res);
          }
        } else {
          if (typeof errFunc === "function") {
            errFunc(res);
          }
        }
      }
    });
}

async function put(
  urlPart: string,
  bodyObj: {},
  succFunc: (res: AxiosResponse) => void,
  errFunc: (res: AxiosResponse | string) => void,
) {
  const options = getDefaultOptions();
  await axios
    .put(urlPart, bodyObj, options)
    .catch(function (error) {
      errorFunction(error, errFunc);
    })
    .then((res) => {
      if (res) {
        if (isSuccessStatus(res)) {
          if (typeof succFunc === "function") {
            succFunc(res);
          }
        } else {
          if (typeof errFunc === "function") {
            errFunc(res);
          }
        }
      }
    });
}

async function deleteRec(
  urlPart: string,
  bodyObj: {},
  succFunc: (res: AxiosResponse) => void,
  errFunc: (res: AxiosResponse | string) => void,
) {
  await axios
    .delete(urlPart, { data: bodyObj })
    .catch((error) => {
      errorFunction(error, errFunc);
    })
    .then((res) => {
      if (res) {
        if (isSuccessStatus(res)) {
          if (typeof succFunc === "function") {
            succFunc(res);
          }
        } else {
          if (typeof errFunc === "function") {
            errFunc(res);
          }
        }
      }
    });
}

function errorFunction(error: any, customErrorFunc?: (error: any) => void) {
  console.error(error);
  // if (error.response) {
  //   // The request was made and the server responded with a status code
  //   // that falls out of the range of 2xx
  //   console.log(error.request);
  //   // console.log(error.response.data);
  //   // console.log(error.response.status);
  //   // console.log(error.response.headers);
  // } else if (error.request) {
  //   // The request was made but no response was received
  //   // `error.request` is an instance of XMLHttpRequest in the browser
  //   // and an instance of http.ClientRequest in node.js
  //   console.log(error.request);
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   //console.log("Error", error.message);
  // }

  if (customErrorFunc && typeof customErrorFunc === "function") {
    customErrorFunc(error);
  }
}

export const BackendApi = {
  get: get,
  post: post,
  put: put,
  delete: deleteRec,
};
